import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./plan.css";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Card, Radio, Checkbox, Collapse, Button, Form, Empty } from "antd/lib";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { message, Spin, InputNumber, Skeleton, Switch } from "antd/lib";
import { selected_quote } from "../../Redux/actions/NumBikeation";
import {
  QuickQuote_Post,
  quick_quoteValues,
  quick_quotes,
  Err_quotes,
} from "../../Redux/actions/NumCaration";
import { SelectAddons } from "../../Redux/actions/NumBikeation";
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { SideCardCar } from "./sidecard";
// import { Premiumbreakup } from "../plansPage/Premiumbreakup";
import Premiumbreakup from "../RolloverBike/Premiumbreakup";
import CarComparePlan from "./CarCompare";
import CompanyFilter from "./CompanyFilter";

function Plan() {
  const auth = useSelector((state) => state.cardetail.carnum);
  const QuotePost = useSelector((state) => state?.cardetail?.quickQuotePost);
  const QQUpdatePost = useSelector((state) => state?.cardetail?.quickQuotePost);
  const QQUpdateElect = useSelector(
    (state) => state?.cardetail?.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  const QQuoteData = useSelector((state) => state?.cardetail?.quickquotes);
  const QQuoteErr = useSelector((state) => state?.cardetail?.errquote);
  const SQQAddons = useSelector((state) => state?.common?.selectedAddons);
  const accessories = useSelector(
    (state) =>
      state?.cardetail?.quickquotes?.data?.contract?.coverages?.accessories
  );
  const CurrentTP = useSelector(
    (state) => state?.cardetail?.prevpolicydetail?.currentThirdPartyPolicy
  );
  const { Panel } = Collapse;
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState(["1", "2"]);
  const [electricalShow, setElectricalShow] = useState(
    QQUpdateElect?.electrical
  );
  const [NonElectricalShow, setNonElectricalShow] = useState(
    QQUpdateElect?.nonElectrical
  );
  const [selectedOption, setSelectedOption] = useState(
    electricalShow ? "electrical" : NonElectricalShow ? "nonElectrical" : null
  );
  const [skullloading, setSkullloading] = useState(true);
  const [CompareQQ, setCompareQQ] = useState([]);
  const [PremiumData, setPremiumData] = useState("");
  const selectedQuotes = QQuoteData?.some((quote) => quote.IsSelected)
    ? QQuoteData.filter((quote) => quote.IsSelected)
    : QQuoteData;
  const { ...selectedObjects } = accessories === undefined ? "" : accessories;

  useEffect(() => {
    dispatch(Err_quotes([]));
    fetchData();
    console.log("QQuoteData", QQuoteData);
  }, []);

  const fetchData = () => {
    setSkullloading(true);
    setLoading(true);
    // v2/car_insurances/{insurance}/quick_quotes

    axiosInCar
      .post(
        `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
        QuotePost
      )
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log(data)
          // console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item?.status === "failed"
          );
          //dispatch(Err_quotes(errData));
          const updatedErrData = errData?.map((item) => {
            try {
              if (typeof item?.errors === "string") {
                const errorResponse = JSON.parse(item?.errors);
                // console.log(errorResponse)
                if ("error" in errorResponse) {
                  return {
                    ...item,
                    errors: errorResponse.error.validationMessages[0],
                  };
                }
              } else if (typeof item?.errors === "object") {
                return {
                  ...item,
                  errors: item?.errors?.error,
                };
              }
            } catch (error) {
              console.error("Error parsing error response:", error);
            }
            return item;
          });
          //console.log(updatedErrData);
          dispatch(Err_quotes(updatedErrData));
          // const Breakin = data?.filter(item => ("motorBreakIn" in item && item?.motorBreakIn.isBreakin === true));
          // console.log('Breakin',Breakin)

          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
            IsSelected: false,
          }));
          // const itemsToDispatch = updatedData.filter(item => item.IsSelected === true || item.IsSelected === false);
          dispatch(quick_quotes(updatedData));
          setSkullloading(false);
          setLoading(false);
          // if(Breakin?.length > 0) {
          //   dispatch(BreakIN_quotes(Breakin));
          // } else {
          //   dispatch(BreakIN_quotes([]))
          // }
        } else {
          setSkullloading(false);
          setLoading(false);
          //console.log(res);
          message.error(res.data.error.validationMessages.join(","));
        }
      })
      .catch((err) => {
        console.log(err.response?.data);
        setSkullloading(false);
        setLoading(false);
        message.error(err?.response?.data?.message);
        if (err?.response?.data?.message == "Unauthenticated.") {
          message.error(
            err?.response?.data?.message + "Your access token has expired."
          );
          dispatch((dispatch) => {
            dispatch({ type: "RESET_CAR" });
            dispatch({ type: "RESET_BIKE" });
          });
          history.push("/");
        } else if (err?.response?.data) {
          //message.error(err.response.da)
        }
      });
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
        color: "#eb1b27",
      }}
      spin
    />
  );

  const onChange = (keys) => {
    //console.log(keys)
    setActiveKey(keys);
  };

  const handlePanel1Click = () => {
    setActiveKey(activeKey.length === 0 ? ["1", "2", "3", "4"] : []);
  };

  const handlePlan = (quote) => {
    //console.log('click quote',quote);
    dispatch(selected_quote(quote));
    history.push("/Customer");
  };

  const handleCheckboxChange = (index) => {
    const updatedQQuoteData = QQuoteData?.map((quote, i) => {
      if (i === index) {
        return { ...quote, compare: !quote.compare };
      }
      return quote;
    });
    // console.log(updatedQQuoteData)
    const trueObjects = updatedQQuoteData.filter((quote) => quote.compare);
    // console.log(trueObjects)
    setCompareQQ(trueObjects);
    dispatch(quick_quotes(updatedQQuoteData));
  };

  const onCheckChange = (e) => {
    // console.log('checked = ', e);
    if (e.target.checked === true) {
      setSkullloading(true);
      setLoading(true);
      // console.log('checked = ', e.target.value);
      let addons = e.target.value;
      // setSelectedAddon(prevSelected => [...prevSelected, addons]);
      dispatch(SelectAddons([...SQQAddons, addons]));
      const updatedQuotePost = {
        ...QQUpdatePost,
        [addons]: true,
        currentThirdPartyPolicy:
          QQUpdatePost?.product_code === "PVP" ? null : CurrentTP,
      };
      // console.log(updatedQuotePost)
      axiosInCar
        .post(
          `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
          updatedQuotePost
        )
        .then((res) => {
          if (res.status === 200) {
            // if (!res.data.error) {
            // let data = {
            //     data: res.data.data,
            // };
            const data = res?.data?.data;
            //console.log(data)
            // console.log("data-----------------",data)
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(Err_quotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(quick_quotes(updatedData));
            //console.log(data)
            //dispatch(quick_quotes(data));
            dispatch(QuickQuote_Post(updatedQuotePost));
            setSkullloading(false);
            setLoading(false);
            // } else {
            // setLoading(false)
            // message.error(res.data.error.validationMessages.join(","));
            // }
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setSkullloading(false);
          setLoading(false);
          //message.error(err.response.data.error);
        });
    } else if (e.target.checked === false) {
      setSkullloading(true);
      setLoading(true);
      // console.log('checked = ', e.target.value);
      let addons = e.target.value;
      const updatedSelectedAddon = SQQAddons.filter(
        (selected) => selected !== addons
      );
      //setSelectedAddon(updatedSelectedAddon);
      dispatch(SelectAddons(updatedSelectedAddon));
      const updatedQuotePost = {
        ...QQUpdatePost,
        [addons]: false,
      };
      // console.log(updatedQuotePost)
      axiosInCar
        .post(
          `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
          updatedQuotePost
        )
        .then((res) => {
          if (res.status === 200) {
            // if (!res.data.error) {
            // let data = {
            //     data: res.data.data,
            // };
            const data = res?.data?.data;
            //console.log(data)
            // console.log("data-----------------",data)
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(Err_quotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(quick_quotes(updatedData));
            //console.log(data)
            //dispatch(quick_quotes(data));
            dispatch(QuickQuote_Post(updatedQuotePost));
            setSkullloading(false);
            setLoading(false);
            // } else {
            // setLoading(false)
            // message.error(res.data.error.validationMessages.join(","));
            // }
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setSkullloading(false);
          setLoading(false);
          //message.error(err.response.data.error);
        });
    }
  };

  const onChangeProduct = ({ target: { value } }) => {
    let ChangeProduct;
    let QuoteValues;
    // console.log('radio4 checked', value);
    //setProductValue(value);
    setLoading(true);
    setSkullloading(true);
    //setSelectedAddon([])
    dispatch(SelectAddons([]));
    QuoteValues = {
      ...QuoteInput,
      productCode: value,
    };
    ChangeProduct = {
      ...QQUpdatePost,
      product_code: value,
      currentThirdPartyPolicy:
        QuotePost?.product_code === "PVP" ? CurrentTP : null,
      tyreProtection: false,
      personalBelonging: false,
      keyAndLockProtect: false,
      emergencyMedicalExpenses: false,
      roadSideAssistance: false,
      returnToInvoice: false,
      engineProtection: false,
      consumables: false,
      partsDepreciation: false,
    };
    console.log("ChangeProduct", ChangeProduct);
    axiosInCar
      .post(
        `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
        ChangeProduct
      )
      .then((res) => {
        if (res.status === 200) {
          // if (!res.data.error) {
          // let data = {
          //   data: res.data.data,
          // };
          const data = res?.data?.data;
          //console.log(data)
          // console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes(updatedData));
          //console.log(data)
          //dispatch(quick_quotes(data));
          dispatch(QuickQuote_Post(ChangeProduct));
          dispatch(quick_quoteValues(QuoteValues));
          dispatch(SelectAddons([]));
          setLoading(false);
          setSkullloading(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err?.response?.data);
        setLoading(false);
        setSkullloading(false);
        //message.error(err.response.data.error);
      });
  };
  const onEectricalChange = (e) => {
    if (e.target.checked === true) {
      setSkullloading(false);
      setLoading(false);
      let Electric = e.target.value;
      console.log(Electric);
      if (Electric === "electrical") {
        setSelectedOption("electrical");
        const updatedQuotePostEL = {
          ...QQUpdateElect,
          electrical: true,
          nonElectrical: false,
        };
        dispatch(QuickQuote_Post(updatedQuotePostEL));
        setElectricalShow(true);
        setNonElectricalShow(false);
      } else if (Electric === "nonElectrical") {
        setSelectedOption("nonElectrical");
        const updatedQuotePostEL = {
          ...QQUpdateElect,
          electrical: false,
          nonElectrical: true,
        };
        dispatch(QuickQuote_Post(updatedQuotePostEL));
        setElectricalShow(false);
        setNonElectricalShow(true);
      }
    } else if (e.target.checked === false) {
      setElectricalShow(false);
      setNonElectricalShow(false);
      setSkullloading(true);
      setLoading(true);
      let Electric = e.target.value;
      console.log(Electric);
      const updatedQuotePost = {
        ...QQUpdateElect,
        [Electric]: false,
        electricalinsuredamount: null,
        nonElectricalinsuredamount: null,
      };
      setSkullloading(false);
      setLoading(false);
      dispatch(QuickQuote_Post(updatedQuotePost));
      if (
        (e.target.checked === false && QQUpdatePost?.electricalinsuredamount) ||
        QQUpdatePost?.nonElectricalinsuredamount
      ) {
        setSkullloading(true);
        setLoading(true);
        axiosInCar
          .post(
            `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
            updatedQuotePost
          )
          .then((res) => {
            if (res.status === 200) {
              const Udata = res?.data?.data;
              //console.log("data-----------------",data)
              const errData = Udata?.filter(
                (item) => "status" in item && item.status === "failed"
              );
              dispatch(Err_quotes(errData));
              const filteredData = Udata?.filter(
                (item) => "status" in item && item.status === "success"
              );
              const updatedData = filteredData?.map((item) => ({
                ...item,
                IsGst: true,
              }));
              dispatch(quick_quotes(updatedData));
              dispatch(QuickQuote_Post(updatedQuotePost));
              setSkullloading(false);
              setLoading(false);
            }
          })
          .catch((err) => {
            console.log(err?.response?.data);
            setLoading(false);
            setSkullloading(false);
          });
      }
    }
  };
  const onFinish = (values) => {
    // console.log('values',values)
    // console.log(selectedOption)
    setLoading(true);
    // console.log(typeof values.electricalinsuredamount)
    let updatedElectric;
    let updatedNonElectric;
    if (selectedOption === "electrical") {
      setSkullloading(true);
      setLoading(true);
      updatedElectric = {
        ...QQUpdatePost,
        electrical: true,
        electricalinsuredamount: values.electricalinsuredamount,
        // electricalminallowed: selectedObjects?.electrical.minAllowed,
        // electricalmaxallowed: selectedObjects?.electrical.maxAllowed,
      };
      axiosInCar
        .post(
          `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
          updatedElectric
        )
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data;
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(Err_quotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(quick_quotes(updatedData));
            dispatch(QuickQuote_Post(updatedElectric));
            setLoading(false);
            setSkullloading(false);
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setLoading(false);
          setSkullloading(false);
          //message.error(err.response.data.error);
        });
    } else if (selectedOption === "nonElectrical") {
      setLoading(true);
      setSkullloading(true);
      updatedNonElectric = {
        ...QQUpdatePost,
        nonElectrical: true,
        nonElectricalinsuredamount: values.nonElectricalinsuredamount,
      };
      //console.log(updatedNonElectric)
      axiosInCar
        .post(
          `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
          updatedNonElectric
        )
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data;
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(Err_quotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(quick_quotes(updatedData));
            dispatch(QuickQuote_Post(updatedNonElectric));
            setLoading(false);
            setSkullloading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          setSkullloading(false);
          console.log(err.response.data.error);
          message.error(err.response.data.error);
        });
    }
  };
  const handleOpen = (quote) => {
    //console.log(quote)
    setPremiumData(quote);
    setShow(true);
  };
  const onGstChange = (checked) => {
    console.log(checked);
    const updatedData = QQuoteData?.map((item) => ({
      ...item,
      IsGst: checked,
    }));
    console.log(updatedData);
    dispatch(quick_quotes(updatedData));
  };
  const formatCurrency = (value) => {
    if (typeof value === "number") {
      return value > 0 ? `₹ ${Math.round(value)}` : null;
      // return `₹ ${Math.round(value)}`;
    }
    if (typeof value === "string") {
      const numericValue = parseFloat(value.replace(/[^\d.]/g, ""));
      return isNaN(numericValue)
        ? "N/A"
        : numericValue > 0
        ? `₹ ${Math.round(numericValue)}`
        : null;
      // return isNaN(numericValue) ? "N/A" : `₹ ${Math.round(numericValue)}`;
    }
    return "N/A";
  };
  return (
    <>
      <div className="site-card-wrapper row justify-content-center px-3">
        <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12">
          <SideCardCar />
          <div className="sideParent-skb mt-4">
            <Spin spinning={loading} indicator={antIcon}>
              <div className="add0n-btn">
                <div className="adondiiv">
                  Addons & Covers
                  <span onClick={handlePanel1Click}>
                    {activeKey.length > 0 ? (
                      <MinusCircleOutlined />
                    ) : (
                      <PlusCircleOutlined />
                    )}
                  </span>
                </div>
              </div>
              <Collapse activeKey={activeKey} onChange={onChange}>
                <Panel header="CPA" key="1">
                  {QuotePost?.policyHolderType === "COMPANY" ||
                  QuoteInput?.insuranceProductCode === "Bundled" ||
                  QuoteInput?.insuranceProductCode === "PVS" ? null : (
                    <div className="addon-collapse-inner">
                      <Checkbox
                        onChange={onCheckChange}
                        value="personalAccident"
                        className="d-flex align-items-center"
                        checked={QuotePost?.personalAccident}
                      >
                        Compulsory Personal Accident
                      </Checkbox>
                    </div>
                  )}
                </Panel>

                <Panel header="Addons" key="2" className="addon-pannel">
                  {QuotePost?.product_code === "PVT" ||
                  QuoteInput?.productCode === "PVT" ? null : (
                    <div className="addon-collapse-inner">
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="partsDepreciation"
                        checked={QuotePost?.partsDepreciation}
                      >
                        Zero Depreciation
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="consumables"
                        checked={QuotePost?.consumables}
                      >
                        consumables
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="engineProtection"
                        checked={QuotePost?.engineProtection}
                      >
                        Engine protector
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="returnToInvoice"
                        checked={QuotePost?.returnToInvoice}
                      >
                        Return To Invoice
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="roadSideAssistance"
                        checked={QuotePost?.roadSideAssistance}
                      >
                        Road Side Assistance
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="emergencyMedicalExpenses"
                        checked={QuotePost?.emergencyMedicalExpenses}
                      >
                        Emergency Medical Expenses
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="keyAndLockProtect"
                        checked={QuotePost?.keyAndLockProtect}
                      >
                        Key Cover
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="personalBelonging"
                        checked={QuotePost?.personalBelonging}
                      >
                        Loss Of Personal Belongings
                      </Checkbox>
                      <Checkbox
                        onChange={onCheckChange}
                        className="add_on_checkbx"
                        value="tyreProtection"
                        checked={QuotePost?.tyreProtection}
                      >
                        Tyre Secure
                      </Checkbox>
                      {/* <Checkbox onChange={onCheckChange} className="add_on_checkbx" value='WindshieldGlass' checked={QuotePost?.WindshieldGlass}>Windshield Glass</Checkbox>             */}
                    </div>
                  )}
                </Panel>
                <Panel header="Accessories" key="3">
                  {QuotePost?.product_code === "PVT" ||
                  QuoteInput?.productCode === "PVT" ? null : (
                    <div className="addon-collapse-inner">
                      <Form
                        onFinish={onFinish}
                        layout="vertical"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Checkbox
                          value="electrical"
                          onChange={onEectricalChange}
                          checked={QQUpdateElect?.electrical}
                        >
                          Electrical
                        </Checkbox>
                        {electricalShow ? (
                          <>
                            <Form.Item
                              name="electricalinsuredamount"
                              initialValue={
                                QQUpdatePost?.electricalinsuredamount
                                  ? QQUpdatePost?.electricalinsuredamount
                                  : null
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter Electrical Amount",
                                },
                              ]}
                            >
                              <InputNumber style={{ width: "60%" }} />
                            </Form.Item>
                          </>
                        ) : null}
                        <Checkbox
                          value="nonElectrical"
                          onChange={onEectricalChange}
                          checked={QQUpdateElect?.nonElectrical}
                        >
                          Non Electrical
                        </Checkbox>
                        {NonElectricalShow ? (
                          <>
                            <Form.Item
                              name="nonElectricalinsuredamount"
                              initialValue={
                                QQUpdatePost?.nonElectricalinsuredamount
                                  ? QQUpdatePost?.nonElectricalinsuredamount
                                  : null
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter NonElectrical Amount",
                                },
                              ]}
                            >
                              <InputNumber style={{ width: "60%" }} />
                            </Form.Item>
                          </>
                        ) : null}
                        {(electricalShow || NonElectricalShow) && (
                          <Form.Item
                            style={{ textAlign: "center", marginTop: "12px" }}
                          >
                            <Button
                              loading={loading}
                              type="primary"
                              htmlType="submit"
                            >
                              Update
                            </Button>
                          </Form.Item>
                        )}
                      </Form>
                    </div>
                  )}
                </Panel>

                <Panel header="Discounts/Deductibles" key="4">
                  {QuoteInput?.insuranceProductCode === "Bundled" ||
                  QuoteInput?.insuranceProductCode === "20203" ? null : (
                    <div className="addon-collapse-inner">
                      <Checkbox
                        onChange={onCheckChange}
                        value="isTPPD"
                        checked={QuotePost?.isTPPD}
                      >
                        TPPD Cover
                      </Checkbox>
                    </div>
                  )}
                </Panel>
              </Collapse>
            </Spin>
          </div>
          <div className="sideParent-skb mt-4">
            <CompanyFilter QQuoteData={QQuoteData} />
          </div>
        </div>
        <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
          <div className="plan-card-head row align-items-center">
            <div className="head1 col-xl-4">Showing: Available plans</div>
            <div className="col-xl-4 col-lg-3 col-md-12 col-sm-12">
              <Radio.Group
                buttonStyle="solid"
                onChange={onChangeProduct}
                // value={QuoteInput?.productCode}
                value={QuotePost?.product_code}
                className="radio-grp-plan-pg"
              >
                {QuoteInput?.insuranceProductCode === "Not_Secure" ? (
                  <>
                    <Radio.Button value="PVP">Comprehensive</Radio.Button>
                    <Radio.Button value="PVT">Third Party</Radio.Button>
                  </>
                ) : QuoteInput?.insuranceProductCode === "Bundled" ? (
                  <>
                    <Radio.Button value="PVS">Own Damage</Radio.Button>
                    <Radio.Button value="PVT" disabled>
                      Third Party
                    </Radio.Button>
                  </>
                ) : (
                  <>
                    <Radio.Button value="PVP">Comprehensive</Radio.Button>
                    <Radio.Button value="PVT">Third Party</Radio.Button>
                  </>
                )}
              </Radio.Group>
            </div>
            <div className="col-xl-2">
              {!skullloading && QQuoteData ? (
                <div className="quotelength">
                  <p className="mb-0">
                    {QQuoteData?.length} <span>Quotes Found</span>
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-xl-2">
              <span className="gst-sec">
                GST
                {skullloading === false ? (
                  <>
                    <Switch
                      defaultChecked
                      checkedChildren="Yes"
                      unCheckedChildren="No"
                      onChange={onGstChange}
                    />
                  </>
                ) : (
                  <Switch
                    loading
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    onChange={onGstChange}
                  />
                )}
              </span>
            </div>
          </div>
          <div className="row gap-3">
            {skullloading && QQuoteData?.length === 0 ? (
              <Card className="plan-card col-xl-4 col-lg-12 col-md-12 col-sm-12">
                <Skeleton
                  active
                  loading={skullloading}
                  paragraph={{ rows: 4 }}
                ></Skeleton>
              </Card>
            ) : null}

            {!skullloading && QQuoteData?.length === 0 ? (
              <div style={{ padding: "30px" }}>
                <Empty description="No Quotes Found" />
              </div>
            ) : (
              <>
                {selectedQuotes?.map((quote, index) => (
                  <Card
                    key={index}
                    className="plan-card col-xl-4 col-lg-12 col-md-12 col-sm-12"
                  >
                    {/* {console.log(quote)} */}
                    <Skeleton
                      active
                      loading={skullloading}
                      paragraph={{ rows: 4 }}
                    >
                      <>
                        <div className="row align-items-center">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <img
                              className="qq-ins-logo"
                              src={quote?.logo}
                              alt=""
                            />
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-6 col-6">
                            <Checkbox
                              checked={quote?.compare}
                              onChange={() => handleCheckboxChange(index)}
                            >
                              Compare
                            </Checkbox>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-6 col-6"></div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                            <div className="idv">IDV Value</div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 text-center col-5">
                            {quote?.IsGst === true ? (
                              <span>incl.GST</span>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div className="row align-items-center">
                          <div className="col-lg-5 col-xl-5 col-md-3 col-sm-3 col-5">
                            <span className="idvPrice">
                              {quote?.product_code === "PVT"
                                ? "Not Applicable"
                                : "₹" + quote?.vehicle?.vehicleIDV?.idv}
                              {/* {quote?.vehicle?.vehicleIDV.idv === 0 ? 'Not Applicable' : '₹' + quote?.vehicle?.vehicleIDV?.idv} */}
                            </span>
                          </div>
                          <div
                            className="col-lg-7 col-md-7 col-sm-7 col-6"
                            style={{ textAlign: "right" }}
                          >
                            <Button
                              className="gross-txt"
                              onClick={() => handlePlan(quote)}
                            >
                              {quote?.IsGst === true ? (
                                <>
                                  ₹{" "}
                                  {typeof quote?.grossPremium === "string"
                                    ? Math.round(
                                        parseFloat(
                                          quote?.grossPremium.replace(
                                            /[^\d.]/g,
                                            ""
                                          )
                                        )
                                      )
                                    : quote?.grossPremium}
                                </>
                              ) : (
                                <>
                                  ₹{" "}
                                  {typeof quote?.netPremium === "string"
                                    ? Math.round(
                                        parseFloat(
                                          quote?.netPremium.replace(
                                            /[^\d.]/g,
                                            ""
                                          )
                                        )
                                      )
                                    : quote?.netPremium}
                                </>
                              )}
                            </Button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                            Base Premium
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-5 text-center">
                            ₹{" "}
                            {typeof quote?.grossPremium === "string"
                              ? Math.round(
                                  parseFloat(
                                    quote?.grossPremium.replace(/[^\d.]/g, "")
                                  )
                                )
                              : quote?.grossPremium}
                          </div>
                        </div>
                        <p
                          className="border-bottom py-2 mb-0"
                          onClick={() => handleOpen(quote)}
                          style={{ color: "blue", cursor: "pointer" }}
                        >
                          View Breakup
                        </p>
                        {/* {quote?.motorBreakIn?.isBreakin === true ? (
                          <p className="text-center text-danger">
                            *Breakin Policy is under develop
                          </p>
                        ) : null} */}
                        {quote?.coverages?.personalAccident && (
                          <>
                            {Object.keys(quote?.coverages).map((key) => {
                              const addon = quote?.coverages[key];
                              if (
                                SQQAddons?.includes(key) &&
                                addon?.selection === true
                              ) {
                                return (
                                  <div className="row" key={key}>
                                    <div className="col-lg-8 col-md-8 col-sm-8 col-8 addonTitle">
                                      {key}
                                    </div>
                                    <div className="col-lg-4 col-md-8 col-sm-8 col-8 available">
                                      {/* {addon.coverAvailability === "AVAILABLE" ? `₹${addon.netPremium.split(' ')[1]}` : addon.coverAvailability} */}
                                      {addon?.coverAvailability ===
                                      "AVAILABLE" ? (
                                        <>
                                          {typeof addon?.netPremium === "string"
                                            ? `₹${
                                                addon?.netPremium.split(" ")[1]
                                              }`
                                            : `₹${addon?.netPremium}`}
                                        </>
                                      ) : (
                                        addon?.coverAvailability
                                      )}
                                    </div>
                                  </div>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </>
                        )}
                        {quote?.coverages?.addons && (
                          <>
                            {Object.keys(quote?.coverages?.addons).map(
                              (key) => {
                                const addon = quote?.coverages?.addons[key];
                                if (
                                  addon?.coverAvailability === "MANDATORY" ||
                                  SQQAddons?.includes(key)
                                ) {
                                  return (
                                    <div
                                      className="row align-items-center addon-display"
                                      key={key}
                                    >
                                      <div className="col-lg-8 col-md-8 col-sm-8 col-8 addonTitle">
                                        {key}
                                      </div>
                                      <div
                                        className={`col-lg-4 col-md-8 col-sm-8 col-8 ${
                                          addon?.coverAvailability ===
                                          "NOT_AVAILABLE"
                                            ? "not-available"
                                            : "available"
                                        }`}
                                      >
                                        {addon?.coverAvailability ===
                                        "MANDATORY"
                                          ? // <>
                                            //   {typeof addon?.netPremium ===
                                            //   "string"
                                            //     ? `₹${
                                            //         addon?.netPremium.split(
                                            //           " "
                                            //         )[1]
                                            //       }`
                                            //     : `₹${addon?.netPremium}`}
                                            // </>
                                            formatCurrency(addon?.netPremium)
                                          : addon?.coverAvailability ===
                                            "NOT_AVAILABLE"
                                          ? "Not Available"
                                          : null}
                                        {key === "keyAndLockProtect" &&
                                        addon?.selection === true &&
                                        addon?.coverAvailability ===
                                          "MANDATORY" &&
                                        addon?.netPremium === 0 ? (
                                          <div
                                            style={{
                                              background: "#f4faff",
                                              borderRadius: "8px",
                                              padding: "2px 8px",
                                            }}
                                          >
                                            Included
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                          </>
                        )}
                      </>
                    </Skeleton>
                  </Card>
                ))}
              </>
            )}
          </div>
          <Modal
            show={show}
            onHide={() => setShow(false)}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            size="lg"
          >
            <Premiumbreakup
              quickQuote={PremiumData}
              Addon={PremiumData?.coverages?.addons}
            />
          </Modal>
        </div>
      </div>
      <div className="d-flex mt-3 justify-content-center">
        <div
          className={`${
            QQuoteErr?.length > 0
              ? `bg-light errQ mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12`
              : `mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12`
          } `}
        >
          {!skullloading && (
            <>
              {QQuoteErr?.length > 0 && (
                <p className="err-q-txt">
                  *We are not getting quote(s) from the following insurers. It
                  might be possible reasons at the insurance company's end like
                  MMV or RTO restricted or might be some technical issue.
                </p>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {QQuoteErr?.map((quote, index) => (
                  <div
                    key={index}
                    className="bg-white p-2 text-center col-xl-2"
                  >
                    <div className="qq-err-txt">
                      <img
                        style={{ width: "100px" }}
                        src={quote?.logo}
                        alt=""
                      />
                      <p>{quote?.message}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <div></div>
      {CompareQQ?.length > 0 ? (
        <CarComparePlan compareQQ={CompareQQ} setCompareQQ={setCompareQQ} />
      ) : null}
    </>
  );
}

export { Plan };
